import * as React from 'react';
import * as navigation from 'app/area/shared/navigation';
import { ButtonPrimary } from 'ui/common/button';
import { authProvider } from 'dependencies/auth';

import styles from './open-case-banner.scss';

export interface OpenCaseBannerProps {
  textHeader: string;
  textCaseNo: string;
  textCasePassword: string;
  textOpenCase: string;
}

export interface OpenCaseBannerState {
  caseNumber?: string;
  casePassword?: string;
}

export class OpenCaseBanner extends React.Component<OpenCaseBannerProps, OpenCaseBannerState> {
  constructor(props: OpenCaseBannerProps) {
    super(props);
    authProvider.setAuthorization(undefined);
    this.state = {
      caseNumber: '',
      casePassword: ''
    };
  }

  private get isInteger() {
    const { caseNumber } = this.state;
    return caseNumber.match(/^\d+$/) && caseNumber.length < 17 && Number(caseNumber) <= Number.MAX_SAFE_INTEGER;
  }

  private onChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (event && event.target && event.target.name) {
      this.setState({
        [event.target.name]: event.target.value
      });
    }
  };

  private onOpenCase = (event: any) => {
    event.preventDefault();
    const { caseNumber, casePassword } = this.state;
    if (!!caseNumber && !!casePassword && this.isInteger) {
      authProvider.setAuthorization(casePassword);
      navigation.toCaseEdit(Number(caseNumber));
    }
  };

  public render() {
    const { textHeader, textCaseNo, textCasePassword, textOpenCase } = this.props;
    const { caseNumber, casePassword } = this.state;

    return (
      <div className="container main-grid">
        <div className={`${styles.openCasePanel}`}>
          <h1>{textHeader}</h1>
          <div className={`input-wrapper ${styles.inputSection}`}>
            <form onSubmit={this.onOpenCase} id="openCase">
              <input
                id="caseNumber"
                name="caseNumber"
                className={`form-control ${styles.inputElement}`}
                type="number"
                placeholder={textCaseNo}
                value={caseNumber}
                onChange={this.onChangeValue}
              />
              <input
                id="casePassword"
                name="casePassword"
                className={`form-control ${styles.inputElement}`}
                type="password"
                placeholder={textCasePassword}
                value={casePassword}
                onChange={this.onChangeValue}
              />
              <ButtonPrimary
                onClick={this.onOpenCase}
                id="open_case"
                disabled={!this.isInteger || !casePassword}
                className={`btn btn-call-to-action ${styles.btnOpenCase}`}
              >
                {textOpenCase}
              </ButtonPrimary>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
